import React, { useEffect, useState } from "react";
import style from "./dashboard.module.scss";
import Skeleton from "../skeleton/skeleton"

const DashBoardSkeleton = (props) => {

    return <div>
        <div>
            <h1><Skeleton type='rectangle' width='130px' height='30px' /></h1>
            <div className={style.welcome}>
                <Skeleton type='rectangle' width='250px' height='30px' />
            </div>
            <div className={style.cardWrapper}>
                <div style={{ marginLeft: '15px', marginBottom: '15px' }}><Skeleton type='rectangle' width='250px' height='86px' /></div>
                <div style={{ marginLeft: '15px', marginBottom: '15px' }}><Skeleton type='rectangle' width='250px' height='86px' /></div>
                <div style={{ marginLeft: '15px', marginBottom: '15px' }}><Skeleton type='rectangle' width='250px' height='86px' /></div>
                <div style={{ marginLeft: '0px', marginBottom: '15px' }}><Skeleton type='rectangle' width='250px' height='86px' /></div>
            </div>
        </div>
    </div>
}
export default DashBoardSkeleton;
